import {ICONS} from './icons/icons.constants';
import {DefaultTagGroupDefinition} from '../types/tags/default-tag-group-definition';

export const defaultTagGroupDefinitions: Array<DefaultTagGroupDefinition> = [
    {
        // Allgemein
        tagGroupDefinitionId: '0a0eb53e-0b7b-4280-8ec1-aa82612d03dd',
        icon: ICONS.PROPGROUP_YELLOW
    },
    {
        // Archivierungs-Einstellungen
        tagGroupDefinitionId: '0274ec60-c1da-471e-8920-0fa98484e077',
        icon: ICONS.PROPGROUP_GREY
    },
    {
        // Basisdokumentdaten
        tagGroupDefinitionId: '4e8bbbb7-1285-4242-ae94-9119acd767ef',
        icon: ICONS.PROPGROUP_BLUE
    },
    {
        // Bearbeitungsinformationen
        tagGroupDefinitionId: '05924ddb-19b7-4bb3-a5a9-32d2ae49df96',
        icon: ICONS.PROPGROUP_GREY
    },
    {
        // Dateiinformationen
        tagGroupDefinitionId: '02685ba0-b08b-416d-8986-542cd77cef1f',
        icon: ICONS.PROPGROUP_GREY
    },
    {
        // E-Rechnung
        tagGroupDefinitionId: 'df18fb13-5672-4421-ae32-9b4e04ada8a3',
        icon: ICONS.PROPGROUP_BLUE
    },
    {
        // E-Rechnung - Position
        tagGroupDefinitionId: '9d91b2fe-6a30-4938-bd21-b436d3944663',
        icon: ICONS.MULTIPROPERTYGROUP_BLUE
    },
    {
        // E-Rechnung - Validierung
        tagGroupDefinitionId: 'b09ed05e-2642-4b4a-926d-aee5b08a9a60',
        icon: ICONS.PROPGROUP_BLUE
    },
    {
        // E-Rechnung - Zahlungsinformation
        tagGroupDefinitionId: '46e3daaf-a7c9-4a1b-9bc8-b249a6a308c4',
        icon: ICONS.MULTIPROPERTYGROUP_BLUE
    },
    {
        // Metadaten
        tagGroupDefinitionId: '0c00ddd7-2d06-466a-b657-ba71c3ea14ba',
        icon: ICONS.PROPGROUP_BLUE
    },
];
